/* eslint-disable no-unused-vars */
import { saveCampaignServiceAPI } from 'services/saveCampaign.service';
import { Loader } from 'components';

export const Table_v2 = ({
  timePeriodFrom,
  timePeriodTo,
  selectedCampaigns$,
  selectedStatusFilter$,
}) => {
  const { data, isLoading, isFetching, isError } =
    saveCampaignServiceAPI.useGetTableCampaignDataQuery({
      from: timePeriodFrom,
      to: timePeriodTo,
      geos: [],
      camp_ids: Array.from(selectedCampaigns$.value),
      statusFilter: selectedStatusFilter$.value,
      startIndex: 0,
      limit: 5,
    });

  if (isFetching) {
    return <Loader.Local delay={0} />;
  }

  return <div>Table_v2</div>;
};
